import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useRouteMatch
} from "react-router-dom";
import Sidebar from "../../mainsidebar/sidebar";
import ContentCss from "../content.css";
import Active from "./Active";
import Get from "./Get";
import Take from "./Take";

const Creative = () => {
  const match = useRouteMatch();
  const LinkAddress = [
    {
      address: "active",
      title: "창조경영활동",
      components: Active
    },
    {
      address: "take",
      title: "창조경영하기",
      components: Take
    },
    {
      address: "get",
      title: "창조경영받기",
      components: Get
    }
  ];
  return (
    <>
      <Router>
        <ContentCss.ContentContainer>
          <ContentCss.ContentSideContainer>
            <div className="SideTitle">
              <p>창조경영</p>
            </div>
            {/* 현재주소를 사이드바로 보내야 사이드바에서 인지 가능 */}
            <Sidebar Linkto={LinkAddress} NowAddress={match}></Sidebar>
          </ContentCss.ContentSideContainer>
          <Switch>
            <ContentCss.ContentMainContainer>
              {/* 기본값으로 보여줄 컴포넌트 */}
              <Route exact path={match.path} component={Active}></Route>
              {LinkAddress.map(data => (
                // path={`${match.path}/${data.address}`}
                <Route
                  key={data.address}
                  path={`${match.path}/${data.address}`}
                  component={data.components}
                ></Route>
              ))}
            </ContentCss.ContentMainContainer>
          </Switch>
        </ContentCss.ContentContainer>
      </Router>
    </>
  );
};

export default Creative;
